import React from 'react'

import styles from './Well.module.css'

export default ({ className = '', children }) =>
  <div className={`well ${styles.well} ${className}`}>
    {children}
  </div>
